import React from 'react';
import { reportBrowserError } from '../services/browserErrorLogger';

export default class BrowserErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportBrowserError({
      source: 'react.error_boundary',
      error,
      message: error?.message || 'React render failure',
      details: {
        componentStack: errorInfo?.componentStack || '',
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', maxWidth: '680px', margin: '0 auto', color: '#1f2937' }}>
          <h2 style={{ marginBottom: '0.75rem' }}>Something went wrong.</h2>
          <p style={{ marginBottom: '1rem' }}>
            The error has been logged. Refresh the page to try again.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              background: '#1f2937',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '0.75rem 1rem',
              cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}